import styled from 'styled-components';
import { Text } from '@amzn/storm-ui';

const PrefixText = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-40027066__sc-1y237dq-0"
})(["white-space:nowrap;"]);
const ProgressIndicatorWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40027066__sc-1y237dq-1"
})(["width:90px;"]);

export { PrefixText as P, ProgressIndicatorWrapper as a };
//# sourceMappingURL=ProgressIndicatorAttribute.styles-4K-BkY9A.js.map
